<template>
  <div class="agreement">
    <div>
      <!-- <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: center;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span style="font-family: '宋体'; font-size: 12pt"
          >橙鹿用户服务协议</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span style="font-family: '宋体'; font-size: 12pt; color: #06112a"
          >&nbsp;</span
        >
      </p> -->
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >尊敬的用户：</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >在您成为橙鹿【平台开发运营主体为橙鹿教育科技（湖北）有限公司】注册用户，使用橙鹿提供的服务之前，请您认真阅读本服务协议</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >后</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >点击同意本协议，未成年人应在其监护人陪同下阅读并决定是否同意接受本协议。</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >标示</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >，您应重点阅读。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #404040;
            background-color: #ffffff;
          "
          >当您阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #404040;
            background-color: #ffffff;
          "
          >达成一致，成为</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #404040;
            background-color: #ffffff;
          "
          >平台“用户”。</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #404040;
            background-color: #ffffff;
          "
          >阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >有权根据国家法律法规的更新、产品和服务规则的调整需要不时地制订、修改本协议及/或各类规则，并提前以网站公示的方式进行公示。您可在</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >查看并下载最新版本的协议规则信息。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >您的使用行为将视为自愿接受和遵守“橙鹿”平台提供的本协议项下服务涉及的包括本协议在内的所有服务规范及相关子协议、管理规范等，包括橙鹿对该服务条款将来可能所做的任何修改。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >&nbsp;</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >一、用户账号注册、密码与安全</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >1. </span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿将对注册用户进行实名认证，</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >您须提供本人真实、正确、最新及完整的注册资料。</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >若您提供任何错误、不实或不完整的资料，或含有违法或违背公序良俗不良信息的，橙鹿有权不予注册或删除用户的注册昵称、个人说明、发布的信息等，有权暂停或终止该用户使用其账号，有权暂停或终止橙鹿提供的全部或部分服务</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >2. </span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >用户不得以营利、任何不正当手段或以违反诚实信用原则等为自己或他人开通、使用本服务，不得售卖、转借账号，不得私自进行账号的交易等违法违规活动。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >3.
          用户有义务保证密码及账号的安全。用户应对利用该密码及账号所进行的一切活动负全部责任</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >，包括任何经由橙鹿</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >上</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >传、下载</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >、张贴、发送电子邮件或任何</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >或其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >资料，无论系公开还是私下传送，均由内容提供者承担责任</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >4.</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >&nbsp;</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >用户的密码或账号遭到未获授权的使用，或者发生</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >任何安全问题时，用户应立即通知橙鹿平台。</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >因平台</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >对</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >用户的</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >任何请求采取行动均需要合理时间，且</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >平台</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >应请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >平台</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >存在法定过错外，</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >平台</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >不承担责任。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >用户不得将账号主动告知第三方或提供给第三方进行使用，如因用户使用不当或者其他非橙鹿导致的账号、密码泄漏，进而造成用户个人隐私泄漏</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >，平台不承担损失及后果，由用户向侵权人追偿；由此导致</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿平台损失的，由用户承担相应的责任。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >5. </span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >由于用户账</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >号</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >关联用户</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >实名</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >信息，仅当有法律明文规定、司法裁定或经</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >平台</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >同意，并符合平台规则规定的用户账</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >号</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >转让流程的情况下，</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >用户</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >可进行账</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >号</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >的转让。账</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >号</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >一经转让，该账</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >号</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >项下权利义务一并转移。</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >除此外，</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >用户</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >的账</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >号</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >不得以任何方式转让，否则</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >平台有权追究</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >用户</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >的违约责任，且由此产生的责任及后果均由</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >用户</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >自行承担</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
          "
          >&nbsp;</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >&nbsp;</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >二、橙鹿服务说明</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >1.
          橙鹿依靠平台自身的技术和运营优势，筛选具有办学资质的成人继续教育机构入驻平台，为学员用户提供合规、权威、专业、丰富、优质的成人学历服务。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >2.
          您注册为橙鹿用户，即有权使用该账号浏览、查看入驻机构上架的学历服务产品，同时入驻机构的专业学历咨询师将根据您的个人需求和情况，为您提供报考政策解读、报考院校信息及报考专业介绍等咨询服务。如您选择购买橙鹿提供的增值服务，橙鹿账号同时也是用户支付增值费用、接受增值服务的凭证。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >3. 使用橙鹿平台，您应具备</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >完全民事</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >权利能力和行为能力。</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
        >
        </span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >4.</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
        >
          橙鹿在提供网络服务时，可能会对部分网络服务收取一定的费用，在此情况下，会在相关页面上做明确的提示。如用户拒绝支付该等费用，则不能使用相关的网络服务。付费业务将在本注册条款的基础上另行规定服务条款，以规范付费业务的内容和双方的权利义务，用户应认真阅读，如用户购买付费业务，则视为接受付费业务的服务条款。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >5. </span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿有权通过拨打电话、发送短信、添加微信、添加QQ或电子邮件等方式，告知用户关于本平台服务相关的宣传信息、推广信息、广告信息、促销优惠等信息，以及邀请用户参与版本测试、用户体验反馈、回访等活动。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >6.</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
        >
          为全面实现用户的服务需求，您同意橙鹿将您的信息分享至本公司开发和运营的其他平台或本公司委托第三方运营的关联平台。因此，您在使用橙鹿平台时，可能会收到前述平台向您发送的开聊、交换微信、联系电话等相关信息。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >7.
          橙鹿的各类增值服务只在产品平台上或由橙鹿直接对外出售或者赠送使用权，用户不得在任何其他平台或渠道购买橙鹿的虚拟产品或服务。因在其他平台充值或找他人代充等方式购买产品或服务导致橙鹿教育科技（湖北）有限公司遭受损失的，用户应当承担违约责任并赔偿损失。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >8</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >.
          用户应通过橙鹿平台使用相关服务，未经许可，不得通过其他第三方工具或运营平台获取橙鹿服务，包括但不限于通过第三方软件登录橙鹿账号、浏览商品/班型等。如因用户使用第三方软件导致相关信息泄漏的，橙鹿教育科技（湖北）有限公司不承担任何责任，且用户还应承担由此给橙鹿教育科技（湖北）有限公司造成的损失。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >&nbsp;</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >三、用户行为规范</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >1.
          本协议所称“平台使用”是指用户使用橙鹿平台服务所进行的任何行为，包括但不限于注册、登录、认证、查看聊天、账号管理、邀约咨询以及其他通过本平台所进行的一切行为。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >2.
          用户在使用橙鹿服务时，应遵守《民法典》《中华人民共和国著作权法》《全国人民代表大会常务委员会关于维护互联网安全的决定》《中华人民共和国保守国家秘密法》《中华人民共和国电信条例》《中华人民共和国计算机信息系统安全保护条例》《中华人民共和国计算机信息网络国际联网管理暂行规定》《计算机信息系统国际联网保密管理规定》《互联网信息服务管理办法》《计算机信息网络国际联网安全保护管理办法》《互联网电子公告服务管理规定》《网络安全法》《中华人民共和国劳动法》及《中华人民共和国劳动合同法》《网络信息内容生态治理规定》等相关中国法律法规的规定。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >3.
          在任何情况下，如果橙鹿平台有理由认为用户使用橙鹿服务过程中的任何行为，包括但不限于用户的任何言论和</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >行为违反或可能违反上述法律和法规的任何规定，本平台可在任何时候不经任何事先通知终止向该用户提供服务。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >4.
          用户承诺在使用橙鹿平台期间，遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >5. 禁止用户利用橙鹿从事下列行为：</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（1）反对宪法所确定的基本原则的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（3）损害国家荣誉和利益的；煽动民族仇恨、民族歧视、破坏民族团结的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（4）破坏国家宗教政策，宣扬邪教和封建迷信的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（5）散布谣言，扰乱社会秩序，破坏社会稳定的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（6）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（7）侮辱或者诽谤他人，侵害他人合法权利的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（8）含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >或</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >有悖道德、令人反感的内容的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（9）含有中国法律、法规、规章、条例以及任何具有法律效力的规范所限制或禁止的</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >内容的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（10）使用橙鹿服务的过程中，以任何方式危害学员合法权益的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（11）冒充任何人或机构，包含但不限于冒充橙鹿工作人员或以虚伪不实的方式陈述或谎称与任何人或机构有关的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（12）发布、传播侵犯任何人的肖像权、名誉权、隐私权、专利权、商标权、著作权、商业秘密的信息或言论的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（13）将病毒</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >或其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >计算机代码、档案和程序，加以上载、张贴、发送电子邮件或</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >以其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >方式传送的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（14）跟踪或</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >以其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >方式骚扰其他用户的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（15）未经合法授权而截获、篡改、收集、储存或删除他人个人信息、电子邮件</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >或其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >数据资料，或将获知的此类资料用于任何非法或不正当目的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（16）以任何方式干扰或企图干扰橙鹿教育科技（湖北）有限公司的任何产品、任何部分或功能的正常运行，或者制作、发布、传播上述工具、方法等。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（17）未能按照橙鹿平台的流程、规则进行注册、认证或使用本服务的，违反本服务功能限制或运营策略，或采取任何措施规避前述流程、规则、限制或策略的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（18）未经橙鹿平台的许可使用插件、外挂或通过其他第三方工具、运营平台或任何服务接入本服务和相关系统的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（19）利用橙鹿账号或橙鹿平台服务从事，包括但不限于欺诈、广告（寻求合作）、传销、刷流量、好评、违法物品营销等任何违法兼职或犯罪活动的。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（20）未经橙鹿教育科技（湖北）有限</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >公司</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >的许可，以任何目的自行或授权、允许、协助任何第三人对平台内的任何信息内容进行非法获取，用于商业用途或其他任何目的。“非法获取”是指采用包括但不限于“蜘蛛”(spider</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >）</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >程序、爬虫程序、拟人程序等非真实用户或避开、破坏技术措施等非正常浏览的手段、方式，读取、复制、转存、获得数据和信息内容的行为。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（21）为任何注册用户或非注册用户提供自动登录到橙鹿平台、代办或协助他人代办身份认证服务的或代售身份认证所需的相关材料或凭据等。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（22）其他任何导致或可能导致橙鹿平台与第三方产生纠纷、争议或诉讼的行为。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >用户如出现上述违法违规行为，橙鹿有权在任何时候不经任何事先通知暂停或终止向该用户提供服务；在发现或接到投诉后，有权采取冻结账户、升级认证或以其他方式暂停向该用户提供服务，并要求用户承担相应的损害赔偿责任。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >&nbsp;</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >四、有限责任条款</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >1.
          橙鹿将尽力为您提供专业的服务，但不保证能满足您的所有要求。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >2.
          入驻机构针对上架的学历服务产品上传的照片、资料、视频、内容及图片等，橙鹿平台不承担任何形式和实质审核义务，不保证其内容的正确性、合法性或可靠性，相关责任由上传上述内容的入驻机构承担。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >3.
          用户应对橙鹿上的其他用户发布的内容自行加以判断，并承担因使用内容而引起的所有风险，包括但不限于因对内容的正确性、完整性或实用性的依赖而产生的风险。本平台无法且不会对因前述风险而导致的任何损失或损害承担责任。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >4.对于用户的投诉，橙鹿平台将尽合理努力进行核实和处理，但不保证一定能满足投诉者的要求。本平台有权决定是否向公众或向被投诉者公开投诉内容。对于投诉内容侵犯用户隐私权、名誉权等合法权利的，所有法律责任由投诉者承担，与本平台无关。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >5.</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >您了解并同意，</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >不对因下述任一情况而导致您的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >或其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >无形损失的损害赔偿</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >：</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >1) 使用或未能使用</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >平台服务；</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >2) 第三方未经批准地使用您的账户或更改您的数据；</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >3) 通过</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >平台服务购买或获取任何商品、样品、数据、信息等行为或替代行为产生的费用及损失；</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >4) 您对</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >平台服务的误解；</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >5) 任何非因</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >的原因而引起的与</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >平台服务有关的</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >其他</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >损失。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >6</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >.</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >您在</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >7</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >.</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >您同意在使用</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >平台服务过程中显示</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >自行或由第三方服务商向您发送的推广或宣传信息（包括商业与非商业信息），其方式和范围可不经向您特别通知而变更。除法律法规明确规定外，您应自行对依该推广信息进行的交易负责，对用户因依该推广信息进行的交易或前述第三方服务商提供的内容而遭受的损失或损害，</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿科技</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >不承担任何责任</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span style="font-family: '宋体'; font-size: 12pt; color: #06112a"
          >&nbsp;</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >&nbsp;</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >五、违约责任</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >1.
          如果橙鹿平台发现或收到他人举报投诉您违反本协议约定或存在任何恶意行为的，</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >本平台有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用部分或全部功能、账号封禁、注销等处罚，并公告处理结果</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >2.
          橙鹿平台有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >3.
          您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；橙鹿平台因此遭受损失的，您也应当一并赔偿。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >4. 除非另有明确的书面说明</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >，</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿不对本平台的运营及其包含在本平台上的信息、内容、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >&nbsp;</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >六、个人信息保护</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >橙鹿平台非常重视您个人信息的保护，在您使用本平台服务时，您同意本平台按照公布的隐私政策收集、存储、使用、披露和保护您的个人信息。</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >因此，橙鹿平台建议您完整地阅读《橙鹿隐私政策》，以帮助您更好地保护您的隐私权，如您不同意请不要开通或停止使用本服务。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >&nbsp;</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >七、通知和送达</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >对于橙鹿平台内的用户，平台为您发送的所有通知均可通过平台站内消息、客户端推送、用户预留的电子邮件、手机短信或其他网络即时通讯工具传送等方式进行，</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >该等通知于发送之日视为已送达用户。请您应确保预留的联系方式正确及有效，并在变更后及时</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >更改用户信息</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >，如因您未提供正确的联系信息或未及时</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >更改</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >新的联系方式，导致无法及时收取通知，将由您自行承担由此产生的损失及法律后果。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >&nbsp;</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >八、争议解决和法律适用</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >1. 如就本协议内容或其执行发生任何争议，应尽量友好协商解决；</span
        ><span
          style="
            font-family: '宋体';
            font-size: 12pt;
            font-weight: bold;
            color: #06112a;
            background-color: #ffffff;
          "
          >协商不成时，争议各方一致同意将发生的争议提交至本协议签订地湖北省武汉市东湖新技术开发区有管辖权的法院进行第一审管辖。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >2.
          本协议条款的生效、履行、解释及争议的解决均适用中华人民共和国法律，本协议条款因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >3.【其他】</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（1）本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 24pt;
          text-align: justify;
          line-height: 15pt;
          background-color: #ffffff;
        "
      >
        <span
          style="
            font-family: '宋体';
            font-size: 12pt;
            color: #06112a;
            background-color: #ffffff;
          "
          >（2）橙鹿平台有权不经您同意即将其在本协议项下的全部权利义务部分或整体转让给任何“橙鹿”的关联公司，但保证该转让行为不会影响或损害您之前享有的权利。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 21pt;
          text-align: justify;
          widows: 0;
          orphans: 0;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'service',
  data() {
    return {};
  },
  mounted() {
    this.changeTitle();
  },
  methods: {
    changeTitle() {
      document.title = '橙鹿用户服务协议';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.agreement {
  height: 100%;
  background: #fff;
  font-size: 26px;
  color: #06112a;
  padding: 20px 20px;
}
.title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  line-height: 36px;
  padding: 30px 0 14px;
}
.agreement-p {
  padding: 0 32px;
}
.agreement-p p {
  line-height: 42px;
  text-align: justify;
}
.p2 {
  font-weight: 800;
}
.agreement-sub {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/view/userservice.vue